import { Box } from '@mentimeter/ragnar-ui/box';
import type { InteractiveCanvasComponents } from '@mentimeter/question-modules-types';
import { TitleSection } from '../../../shared/components/title-section/TitleSection';
import { WordCloudVisualization } from './WordCloudVisualization';

// copy pasted for now
const WORD_CLOUD_TEXTS = [
  { text: 'creative', count: 8 },
  { text: 'bold', count: 3 },
  { text: 'fast', count: 8 },
  { text: 'inspiration', count: 1 },
  { text: 'transpiration', count: 2 },
  { text: 'leader', count: 5 },
  { text: 'focus', count: 4 },
  { text: 'leadership', count: 2 },
  { text: 'quick', count: 3 },
  { text: 'inspirational', count: 2 },
  { text: 'inspire', count: 3 },
  { text: 'top', count: 2 },
  { text: 'quality', count: 5 },
  { text: 'sharing', count: 2 },
  { text: 'leading', count: 2 },
  { text: 'integration', count: 2 },
  { text: 'innovative', count: 1 },
  { text: 'performance', count: 1 },
  { text: 'innovation', count: 1 },
  { text: 'transformers', count: 1 },
  { text: 'change', count: 1 },
];

const NUMBER_OF_ANSWERS = 7;
const PREVIEW_ANSWERS = WORD_CLOUD_TEXTS.slice(0, NUMBER_OF_ANSWERS);
const PREVIEW_DATA_WITH_VALUE = PREVIEW_ANSWERS.map((item) => ({
  ...item,
  value: item.count,
}));

interface EditorEmptyStateProps {
  title: string;
  styledTitle: Record<string, unknown>;
  label: string;
  longerDescription: string;
  fontSizeOffset: -2 | -1 | 0 | 1 | 2;
  CanvasVisualizationArea: InteractiveCanvasComponents['CanvasVisualizationArea'];
  textAccessibleColors: Array<string> | undefined;
}

export const EditorEmptyState = ({
  title,
  styledTitle,
  label,
  longerDescription,
  fontSizeOffset,
  CanvasVisualizationArea,
  textAccessibleColors,
}: EditorEmptyStateProps) => {
  const ConditionalWrapper = CanvasVisualizationArea ?? Box;

  return (
    <Box
      width="100%"
      height="100%"
      data-testid="presentation-container"
      justifyContent="center"
    >
      <TitleSection
        title={title}
        styledTitle={styledTitle}
        description={longerDescription}
        label={label}
        fontSizeOffset={fontSizeOffset}
        showTextSizeDropdown={true}
      />

      <ConditionalWrapper
        flex="1"
        width="100%"
        height="75%"
        extend={() => ({
          '& svg': {
            opacity: 0.3,
          },
        })}
      >
        <WordCloudVisualization
          shouldAnimate={false}
          shouldHideResults={false}
          results={PREVIEW_DATA_WITH_VALUE}
          onRemoveWord={undefined}
          textAccessibleColors={textAccessibleColors}
        />
      </ConditionalWrapper>
    </Box>
  );
};
